import React, { useEffect, useRef, useState } from 'react';
import {
  withDrawl,
  closingBalanceInput,
  withdrInput,
  depositInput,
  particularInput,
  tranInput,
  deleteColumn,
  tableRow,
  bodyStyle
} from './ManuallyAddBankStatement.module.css';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import numberFormat from '../../../../common/constants/NumberFormat';
import moment from 'moment';
import { getAuthToken } from '../../../utils/cookie-utils';
let FormData = require('form-data');
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  addBankStatementTransaction,
  updateBankStatementTransaction
} from '../../../../common/constants/bank-statement-api';
import Tooltip from '@material-ui/core/Tooltip';
const TableBody = ({
  each,
  index,
  keyV,
  transactionDetaiils,
  setTransactionDetails,
  getNumber,
  inputFocus,
  setInputFocus,
  openingBalance,
  leadId,
  applicantId,
  docId,
  name,
  primaryTags
}) => {
  const checkNumber = number => {
    if (!number || !isNaN(number?.replace(/,/g, ''))) return true;
  };
  const getNumberFormat = val => {
    if (!val) return '';
    return numberFormat(parseFloat(val?.replace(/,/g, '')));
  };

  const [particular, setParticular] = useState(each?.description);
  const [deposit, setDeposite] = useState(
    each?.is_credit ? each?.amount : undefined
  );
  const optionRef = useRef();
  const [withDraw, setWithDraw] = useState(
    !each?.is_credit ? each?.amount : undefined
  );
  const [closingAmt, setClosingAmt] = useState(each?.['closing Balance']);
  const [trnsDate, setTransDate] = useState(
    each?.transaction_date &&
      moment(each?.transaction_date).format('YYYY-MM-DD')
  );
  const dateFieldRef = useRef();
  const [errors, setErrors] = useState({});
  const [triggerUpdateData, setTriggerUpdate] = useState('undefined');
  const rowRef = useRef();
  const [selectedTag, setSelectedTag] = useState(
    each?.tag
      ? { value: each?.tag, label: each?.tag }
      : { value: '', label: 'Select Tag' }
  );
  const particularRef = useRef('');
  const [showRowProgress, setShowRowProgress] = useState('');
  const [isFieldsUpdated, setIsFieldUpdated] = useState(false);
  const [height, setHeight] = useState(each?.height || '35px');
  const [apiError, setApiError] = useState('');
  const [id, setId] = useState(each?.id);

  const tbody = ` ${bodyStyle}`;

  //common Data format
  const getDataFormat = () => {
    return {
      date: trnsDate,
      particular: particular,
      tag: selectedTag,
      deposit: deposit,
      withDraw: withDraw,
      closingBalance: closingAmt,
      height: height
    };
  };

  const updateError = () =>
    new Promise((resolve, reject) => {
      let errors = {};
      trnsDate && moment(trnsDate).isValid()
        ? (errors['trnsDate'] = false)
        : (errors['trnsDate'] = true);
      particular
        ? (errors['particular'] = false)
        : (errors['particular'] = true);
      closingAmt
        ? (errors['closingAmt'] = false)
        : (errors['closingAmt'] = true);
      if ((!withDraw && !deposit) || (withDraw && deposit)) {
        errors['withDraw'] = true;
        errors['deposit'] = true;
      } else {
        errors['withDraw'] = false;
        errors['deposit'] = false;
      }
      if (Object.keys(errors).find(each => errors[each])) {
        reject();
        dateFieldRef?.current?.focus();
      } else {
        resolve();
      }
      setErrors(errors);
      return true;
    });

  const addTheTrnsToDb = () => {
    let data = new FormData();
    data.append('applicant_id', applicantId);
    data.append('closingBalance', closingAmt?.replace(/,/g, '') || 0);
    data.append('credit', deposit?.replace(/,/g, '') || 0);
    data.append('debit', withDraw?.replace(/,/g, '') || 0);
    data.append('doc_id', docId);
    data.append('lead_id', leadId);
    data.append('token', getAuthToken());
    data.append('description', particular);
    data.append('primaryTag', selectedTag?.value);
    data.append('transaction_date', trnsDate);
    setShowRowProgress('loading');
    addBankStatementTransaction({
      payLoad: data
    })
      .then(res => {
        setShowRowProgress('success');
        setIsFieldUpdated(false);
        setId(res?.transaction_id);
      })
      .catch(error => {
        setShowRowProgress('failed');
        setIsFieldUpdated(false);
        setApiError(
          `${'please check the data! Click to resubmit!'}`?.toString()
        );
      });
  };

  const updateTheTrnaToBD = () => {
    let data = new FormData();
    data.append('new_description', particular);
    data.append('new_credit', deposit?.replace(/,/g, '') || 0);
    data.append('new_closingBalance', closingAmt?.replace(/,/g, '') || 0);
    data.append('token', getAuthToken());
    data.append('new_debit', withDraw?.replace(/,/g, '') || 0);
    data.append('new_transaction_date', trnsDate);
    data.append('id', id);
    data.append('primary_tag', selectedTag?.value);
    setShowRowProgress('loading');
    updateBankStatementTransaction({
      payLoad: data
    })
      .then(res => {
        setShowRowProgress('success');
        setIsFieldUpdated(false);
      })
      .catch(error => {
        setShowRowProgress('failed');
        setIsFieldUpdated(false);
        setApiError(
          `${'please check the data! Click to resubmit!'}`?.toString()
        );
      });
  };


  //update or add data with autoadd or recalculate
  const updateData = async ({ autoAdd = false, isReSubmit = false }) => {
    await updateError()
      .then(res => {
        if (!id && (isFieldsUpdated || isReSubmit)) addTheTrnsToDb();
        else if (id && (isFieldsUpdated || isReSubmit)) updateTheTrnaToBD();

        let data = transactionDetaiils;
        data[index] = getDataFormat();
        if (autoAdd && name == 'newTransaction') {
          if (index === transactionDetaiils?.length - 1) {
            setTransactionDetails([...data, {}]);
          } else {
            setTransactionDetails([...data]);
          }
          setInputFocus(index + 1);
        } else {
          setTransactionDetails(data);
        }
      })
      .catch(err => {
        dateFieldRef?.current?.focus();
      });
  };

  //handles  onclick trigger by  clikc event listner
  const handleClick = e => {
    //for rows
    if (
      (typeof rowRef?.current?.contains == 'function' &&
        rowRef?.current.contains(e.target)) ||
      (typeof optionRef?.current?.contains == 'function' &&
        optionRef?.current.contains(e.target))
    ) {
      setTriggerUpdate('containsArea');
    } else {
      setTriggerUpdate('notContainsArea');
    }
  };

  //adding event listners
  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  // handle withdraw onChange
  const handleKeyPress = e => {
    if (e.key == 'Tab' && closingAmt) {
      updateData({ autoAdd: true });
    }
  };
  //handle textarea change
  const onChangeTextarea = e => {
    setHeight(`${e.target.scrollHeight}px`);
    setParticular(e.target.value);
    setIsFieldUpdated(true);
  };
  useEffect(() => {
    setHeight(`${particularRef?.current?.scrollHeight}px`);
  }, [particular]);

  //handle closing Amount
  const handleClosingAmt = async () => {
    let totalBalance = openingBalance;
    if (index != 0) {
      totalBalance = transactionDetaiils[index - 1]?.closingBalance;
    } else if (totalBalance && totalBalance?.includes('Rs')) {
      totalBalance = totalBalance?.replace(/Rs/g, '');
    }
    return totalBalance;
  };

  //handle closing amount with deposite chnage
  const handleClosingAmtDeposite = async val => {
    let totalBalance = await handleClosingAmt();
    setClosingAmt(numberFormat(getNumber(totalBalance) + getNumber(val)));
  };

  //handle closing amount with withdraw chnage
  const handleClosingAmtWithdra = async val => {
    let totalBalance = await handleClosingAmt();
    setClosingAmt(numberFormat(getNumber(totalBalance) - getNumber(val)));
  };

  //handle deposite chnage
  const handleDeposite = e => {
    let val = e.target.value;
    if (checkNumber(val)) {
      setDeposite(getNumberFormat(val));
      handleClosingAmtDeposite(val);
      setIsFieldUpdated(true);
    }
  };

  //handle withdraw chnage
  const handleWithDraw = e => {
    let val = e.target.value;
    if (checkNumber(val)) {
      setWithDraw(getNumberFormat(val));
      handleClosingAmtWithdra(val);
      setIsFieldUpdated(true);
    }
  };

  useEffect(() => {
    if (isFieldsUpdated && triggerUpdateData === 'notContainsArea') {
      updateData({});
    }
  }, [triggerUpdateData]);

  const handleFocus = e => {
    e.target?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  };

  useEffect(() => {
    if (inputFocus == keyV) {
      dateFieldRef?.current?.focus();
    }
  }, []);

  const handleResubmit = e => {
    updateData({ isReSubmit: true });
  };
  return (
    <tr key={keyV} className={tableRow} ref={rowRef}>
      <td style={{ width: '30px' }}>
        <div className={deleteColumn} style={{ width: '30px' }}>
          {showRowProgress == 'loading' && (
            <CircularProgress style={{ width: '20px', height: '20px' }} />
          )}
          {showRowProgress == 'success' && (
            <CheckCircleIcon
              className="text-green-1000"
              style={{ width: '20px', height: '20px' }}
            />
          )}
          <div className={showRowProgress != 'failed' && 'hidden'}>
            <Tooltip title={apiError} aria-label="add">
              <ErrorIcon
                className="text-red-500 cursor-pointer"
                style={{ width: '20px', height: '20px' }}
                onClick={handleResubmit}
              />
            </Tooltip>
          </div>
        </div>
      </td>
      <td className={`${tbody}`}>
        <div className={``}>
          <input
            type="date"
            ref={dateFieldRef}
            className={`py-2 px-1 border-0 rounded bg-grey-1004 text-black-1015 font-barlow ${tranInput} ${errors?.trnsDate &&
              'border border-red-200'} `}
            value={trnsDate}
            onChange={e => {
              setTransDate(e.target.value);
              setIsFieldUpdated(true);
            }}
            style={{ height: height }}
            onFocus={handleFocus}
          />
        </div>
      </td>
      <td className={`${tbody} w-full`}>
        <textarea
          ref={particularRef}
          className={`w-full py-2 px-1 border-0 rounded bg-grey-1004 text-black-1015 font-barlow  ${particularInput} ${errors?.particular &&
            'border border-red-200'}`}
          onChange={onChangeTextarea}
          value={particular}
          style={{ height: height }}
          onFocus={handleFocus}
        />
      </td>
      <td style={{ minWidth: '150px' }}>
        <CommonSelect
          name="tags"
          value={selectedTag}
          onChange={e => {
            setSelectedTag({ value: e.value, label: e.label });
            setIsFieldUpdated(true);
          }}
          onBlur={() => {}}
          optionRefParent={optionRef}
          useParentOptionRef={true}
          options={primaryTags}
          stylesContainer={{
            height: height,
            marginBottom: '0px',
            fontSize: '40px',
            paddingRight: '20px'
          }}
          dropdownStyle={{
            top: height,
            fontSize: '16px',
            backgroundColor: '#fff',
            paddingRight: '2px',
            alignItems: 'center',
            fontFamily: 'Roboto',
            fontWeight: 400
          }}
          styleText={{
            fontSize: '16px',
            padding: '4.5px 4px 4.5px 16px',
            color: '#8D8D8D',
            fontFamily: 'Roboto'
          }}
          useTimeOut={true}
          timeOutValue={200}
        
        />
      </td>
      <td className={`${tbody}`}>
        <div className={``}>
          <input
            className={`py-2 px-1 border-0 rounded bg-grey-1004 text-black-1015 font-barlow  ${depositInput} ${errors?.deposit &&
              'border border-red-200'}`}
            value={deposit}
            onChange={handleDeposite}
            disabled={withDraw}
            style={{ height: height }}
            onFocus={handleFocus}
          />
        </div>
      </td>
      <td className={`${tbody}`}>
        <div
          className={`${withDrawl} ${errors?.withDraw &&
            'border border-red-200'}`}
        >
          <input
            className={`py-2 px-1 border-0 rounded bg-grey-1004 text-black-1015 font-barlow  ${withdrInput} `}
            style={{
              borderRadius: '0px',
              borderTopLeftRadius: '25px',
              height: height
            }}
            value={withDraw}
            onChange={handleWithDraw}
            disabled={deposit}
            onFocus={handleFocus}
          />
        </div>
      </td>
      <td className={`${tbody}`}>
        <div className={`w-full`}>
          <input
            className={`w-full py-2 px-1 border-0 rounded bg-grey-1004 text-black-1015 font-barlow  ${closingBalanceInput} ${errors?.closingAmt &&
              'border border-red-200'}`}
            value={closingAmt}
            style={{ height: height }}
            onFocus={handleFocus}
            onKeyDown={handleKeyPress}
            onChange={e => {
              setClosingAmt(e.target.value);
              setIsFieldUpdated(true);
            }}
          />
        </div>
      </td>
    </tr>
  );
};

export default TableBody;
